import { useBreakpoints } from "@vueuse/core";
import { computed, ref, watch } from "vue";

export default function useBreakpointsElement(drawerStandardSize?: string) {
  const breakpoints = useBreakpoints({
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1920
  });

  const isMobile = ref(false);
  const defaultDrawerSize = drawerStandardSize || "600px";

  const resolution = computed(() => breakpoints.smallerOrEqual("sm").value);

  const drawerSize = computed(() => {
    return isMobile.value ? "100%" : defaultDrawerSize;
  });

  watch(
    () => resolution.value,
    (value) => {
      isMobile.value = value;
    },
    { immediate: true }
  );

  return {
    breakpoints,
    isMobile,
    drawerSize
  };
}
